import React, { useState, useEffect } from "react";
import {useNavigate } from "react-router-dom";
import TimeIcon from "../../assets/icons/timeIcon.svg";
import Frame from "../../assets/icons/frame.svg";
import { Wrapper, TitleDiv, DraftRoomContainer, DraftIconsContainer } from "./Room.styles";
import { API_ENDPOINT } from "../../config/config";
import axios from "axios";
import Spinner from "../../components/Spinner/Spinner";
import axiosInstance from "../../service/axiosInstance";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";


const Room = () => {
    const [teams, setTeams] = useState([]);
    const [activeTeam, setActiveTeam] = useState(null);
    const [loading, setLoading] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [timerStarted, setTimerStarted] = useState(false);
    const navigate=useNavigate();
    const [roomEvent, setRoomEvent] = useState([]);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const { id } = useParams();



    const handleGetEventConfig = async () => {
        setLoadingRequest(true);
        try {
            const response = await axiosInstance.get(
                `${API_ENDPOINT}event-config/`,
            );
            const roomData = response.data.results.find(item => item.id === Number(id));
            setRoomEvent(roomData)
        } catch (err) {
            console.error(err);
            toast.error("Error fetching data!");
        } finally {
            setLoadingRequest(false);
        }
    };

    useEffect(() => {
        handleGetEventConfig();
    }, []);


    useEffect(() => {
        if (!roomEvent?.selected_date_time) return;
        const targetTime = new Date(roomEvent.selected_date_time).getTime();
        const updateTime = () => {
            const now = Date.now();
            const diffInSeconds = Math.max(Math.floor((targetTime - now) / 1000), 0);
            setTimeLeft(diffInSeconds);
        };
        updateTime();
        setTimerStarted(true);
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, [roomEvent?.selected_date_time]);

    const formatTime = (seconds) => {
        const days = Math.floor(seconds / (24 * 3600));
        const hours = Math.floor((seconds % (24 * 3600)) / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${days}d ${hours.toString().padStart(2,"0")}h:${minutes.toString().padStart(2,"0")}m:${secs.toString().padStart(2,"0")}s`;
    };


    console.log("Target UTC:", new Date(roomEvent.selected_date_time).toUTCString());
    console.log("Now UTC:", new Date().toUTCString());
    console.log("Diff in seconds:", Math.floor((new Date(roomEvent.selected_date_time).getTime() - Date.now()) / 1000));


    useEffect(() => {
        if (timerStarted && timeLeft === 0) {
            navigate(`/draft-room/${id}`);
        }
    }, [timeLeft, timerStarted, navigate]);

    useEffect(() => {
        if (roomEvent?.team) {
            getTeams();
        }
    }, [roomEvent]);

    const getTeams = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${API_ENDPOINT}trade-value-history/?limit=1000&offset=0&round=&round_index_number=7&tm=`
            );
            const teams = res.data.results;
            const teamSet = [];
            for (let team of teams) {
                const teamRound = team.round;
                const checkTeam = teamSet.some((t) => t.name === teamRound.name);
                if (!checkTeam) {
                    teamSet.push({
                        ...teamRound,
                        selection: team.index,
                        draftCountId: team.team_neads_info.id,
                    });
                }
            }
            const updatedTeams = teamSet.map((team) => ({
                ...team,
                choosePlayers: [],
            }));
            setTeams(updatedTeams);
            if (roomEvent?.team) {
                const matchedTeam = updatedTeams.find(
                    (t) => t.name.toLowerCase() === roomEvent.team.toLowerCase()
                );
                if (matchedTeam) {
                    setActiveTeam(matchedTeam.id);
                }
            }
        } catch (error) {
            console.error("Error fetching teams:", error);
        } finally {
            setLoading(false);
        }
    };

    const renderTeamIcons = teams.map((item) => (
        <div
            className={`iconDiv ${activeTeam === item.id ? "active" : ""}`}
            key={item.id}>
            <img src={item.logo} alt="logo" />
        </div>
    ));

    return (
        <Wrapper className="main-container">
            <TitleDiv>
               <div></div>
                <div className="title">Draft Start In</div>
                <div>
                    <img src={Frame} alt="" />
                </div>
            </TitleDiv>
                <DraftRoomContainer>
                    <div className="timeDiv">
                        <div className="timeRemaining">
                            <img src={TimeIcon} alt="timeIcon" />
                            <span
                                style={{
                                    fontSize: "24px",
                                    fontWeight: "bold",
                                    color: timeLeft > 10 ? "#28a745" : "#d9534f",
                                    marginLeft: "10px",
                                }}
                            >
                  {formatTime(timeLeft)}
                </span>
                        </div>
                    </div>
                    <p>{roomEvent?.rounds} Rounds Fast Trades</p>
                    <DraftIconsContainer>
                        {loading ? (
                            <div style={{ margin: "auto" }}>
                                <Spinner />
                            </div>
                        ) : (
                            renderTeamIcons
                        )}
                    </DraftIconsContainer>
                </DraftRoomContainer>
        </Wrapper>
    );
};

export default Room;
